import { forwardRef } from 'react';

export const ListIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M3.33334 8.75C2.64168 8.75 2.08334 9.30833 2.08334 10C2.08334 10.6917 2.64168 11.25 3.33334 11.25C4.02501 11.25 4.58334 10.6917 4.58334 10C4.58334 9.30833 4.02501 8.75 3.33334 8.75ZM3.33334 3.75C2.64168 3.75 2.08334 4.30833 2.08334 5C2.08334 5.69167 2.64168 6.25 3.33334 6.25C4.02501 6.25 4.58334 5.69167 4.58334 5C4.58334 4.30833 4.02501 3.75 3.33334 3.75ZM3.33334 13.75C2.64168 13.75 2.08334 14.3167 2.08334 15C2.08334 15.6833 2.65001 16.25 3.33334 16.25C4.01668 16.25 4.58334 15.6833 4.58334 15C4.58334 14.3167 4.02501 13.75 3.33334 13.75ZM5.83334 15.8333H17.5V14.1667H5.83334V15.8333ZM5.83334 10.8333H17.5V9.16667H5.83334V10.8333ZM5.83334 4.16667V5.83333H17.5V4.16667H5.83334Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);
